import { Component } from '@angular/core';

@Component({
  selector: 'app-auxiliary-equipment',
  templateUrl: './auxiliary-equipment.component.html',
  styleUrls: ['./auxiliary-equipment.component.scss']
})
export class AuxiliaryEquipmentComponent {
  conveyersystem:any[] = [
    {
      title: 'Blowers',
      img: 'assets/images/capability/white/auxilary_1.JPG',
    },
    {
      title: 'Mold Temperature Controller',
      img: 'assets/images/capability/white/auxilary_2.JPG',
    },
    {
      title: 'Granulators​',
      img: 'assets/images/capability/white/auxilary_3.JPG',
    },
    {
      title: 'Vacuum Loader',
      img: 'assets/images/capability/white/auxilary_4.JPG',
    },
    {
      title: 'Blender and Dosing Unit',
      img: 'assets/images/capability/white/auxilary_5.JPG',
    },
    {
      title: 'Dehumidifying & Hot Air Dryers​',
      img: 'assets/images/capability/white/auxilary_6.JPG',
    },
    {
      title: 'Centralized Feeding System​',
      img: 'assets/images/capability/white/auxilary_7.JPG',
    },
    {
      title: 'Water Flow Regulators​',
      img: 'assets/images/capability/white/auxilary_8.JPG',
    },
    {
      title: 'Descaling Unit​',
      img: 'assets/images/capability/white/auxilary_9.JPG',
    },
    {
      title: 'In Mold Labelling​',
      img: 'assets/images/capability/white/auxilary_10.JPG',
    },
    {
      title: 'Hopper Magnet and metal separator​',
      img: 'assets/images/capability/white/auxilary_11.JPG',
    }
  ]

  materialmove:any[] = [
    {
      title: 'Descaling and Flushing System',
      img: 'assets/images/capability/white/auxilary_12.JPG',
    },
    {
      title: 'Mould Service Table',
      img: 'assets/images/capability/white/auxilary_13.JPG',
    },
    {
      title: 'Die Spotting Press​',
      img: 'assets/images/capability/white/auxilary_14.JPG',
    },
    {
      title: 'Hydraulic Quick Die Change System',
      img: 'assets/images/capability/white/auxilary_15.JPG',
    },
    {
      title: 'Magnetic Quick Die Change Clamps',
      img: 'assets/images/capability/white/auxilary_16.JPG',
    },
    {
      title: 'Deep Hole Drilling System​',
      img: 'assets/images/capability/white/auxilary_17.JPG',
    }
  ]

  materialstorage:any[] = [
    {
      title: 'Water Cooled Chiller',
      img: 'assets/images/capability/white/auxilary_18.JPG',
    },
    {
      title: 'Air Cooled Chiller',
      img: 'assets/images/capability/white/auxilary_19.JPG',
    },
    {
      title: 'Industrial Chiller​',
      img: 'assets/images/capability/white/auxilary_20.JPG',
    },
    {
      title: 'Adiabatic Cooler',
      img: 'assets/images/capability/white/auxilary_21.JPG',
    },
    {
      title: 'Modular Chiller',
      img: 'assets/images/capability/white/auxilary_22.JPG',
    },
    {
      title: 'Customized cooling systems​',
      img: 'assets/images/capability/white/auxilary_23.JPG',
    }
  ]


  aircompress:any[] = [
    {
      title: 'Reciprocating Compressor',
      img: 'assets/images/capability/white/auxilary_24.JPG',
    },
    {
      title: 'Screw Compressor',
      img: 'assets/images/capability/white/auxilary_25.JPG',
    },
    {
      title: 'Reciprocating Compressor​',
      img: 'assets/images/capability/white/auxilary_26.JPG',
    },
    {
      title: 'Tank Mounted Screw Compressor',
      img: 'assets/images/capability/white/auxilary_27.JPG',
    },
    {
      title: 'Scroll Compressor',
      img: 'assets/images/capability/white/auxilary_28.JPG',
    },
    {
      title: 'Claw Compressor​',
      img: 'assets/images/capability/white/auxilary_29.JPG',
    },
    {
      title: 'Direct Drive Screw Compressor​',
      img: 'assets/images/capability/white/auxilary_30.JPG',
    },
    {
      title: 'Belt Driven Screw Compressor​',
      img: 'assets/images/capability/white/auxilary_31.JPG',
    },
  ]

  vaccum:any[] = [
    {
      title: 'Rotary Vane Vacuum Pump',
      img: 'assets/images/capability/white/auxilary_32.JPG',
    },
    {
      title: 'Reciprocating Vacuum Pump',
      img: 'assets/images/capability/white/auxilary_33.JPG',
    },
    {
      title: 'AIRD Refrigerant Air Dryer​',
      img: 'assets/images/capability/white/auxilary_34.JPG',
    },
    {
      title: 'Air Filter Accessories',
      img: 'assets/images/capability/white/auxilary_35.JPG',
    },
    {
      title: 'Tank',
      img: 'assets/images/capability/white/auxilary_36.JPG',
    },
    // {
    //   title: 'Claw Compressor​',
    //   img: 'assets/images/placeholder.jpg',
    // },
    // {
    //   title: 'Direct Drive Screw Compressor​',
    //   img: 'assets/images/placeholder.jpg',
    // },
    // {
    //   title: 'Belt Driven Screw Compressor​',
    //   img: 'assets/images/placeholder.jpg',
    // },
  ]
}
